import { OrganisationCard } from "./CRUDs/entities/OrganisationCard";
import { EntityModalForm } from "./CRUDs/abstracts/mixins/EntityModalForm";
import { SaveButton } from "./components/SaveButton";

export default {

    orgId:null,

    init(){
        let saveButton = new SaveButton('#create-org-form')
        $('body').off('click', '#create-org-page #btn-create-edit-org')
        .on('click', '#create-org-page #btn-create-edit-org', function(ev){
            let url = $(ev.target).data('route')
            let form = $('#create-org-form')
            let data = new FormData(form[0])
            if(this.orgId)
                data.append('org_id', this.orgId)
            let $this = this
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                beforeSend:()=>{
                    saveButton.startLoading()
                },
                success: function(response) {
                    if(response?.org_id)
                        $this.orgId = response?.org_id
                    if(!response?.success){
                        if (response?.card_required && response?.stripe_acc) {
                            $("head").append(`<meta name="org-stripe-id" content="${response?.stripe_acc}">`);
                            const planId = $('#create-org-form input[name="plan"]').val()
                            const staticCard = new OrganisationCard(null, { accept_plan_id: planId, is_new_org:true });
                            staticCard.successSubmitCallback = ()=>{
                                window.location.replace(window.location.origin+'/dashboard')
                            }
                            staticCard.openModal('create',{is_new_org:true});
                        } else if (response?.modal) {
                            const formHTML = response.modal;
                            EntityModalForm.pasteForm(formHTML);
                            $('.modal-backdrop').first().remove();
                            $('#failed-action-modal').modal('show');
                        }
                    }else{
                        if(response?.redirect){
                            window.location.replace(response?.redirect)
                        }else{
                            window.location.replace(window.location.origin+'/dashboard')
                        }
                    }
                    saveButton.stopLoading(false,'Create')
                },
                error:()=>{
                    saveButton.stopLoading(false,'Create')
                }
            });
        })
    }
}